export const PRICE_TYPE_BASE = 'base price';
export const PRICE_TYPE_MINIMUM = 'minimum price';

export const MARKUP_TYPE_UP = 'mark up';
export const MARKUP_TYPE_DOWN = 'mark down';
